// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2IDx9","assignButton":"CreateEditEquipmentSchedule_assignButton__1QP3c"};